// @core/api/endpoints/billing/create_account.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateAccountRequest,
  CreateAccountResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Create account in Chart of Accounts
 * Creates a new account in the Chart of Accounts for double-entry bookkeeping. Accounts can be assets, liabilities, equity, revenue, or expenses.
 */
export async function CreateAccount(
  data: CreateAccountRequest,
  options?: RequestOptions
): Promise<CreateAccountResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/accounts`;
  const requestOptions = options;
  return client.post<CreateAccountResponse>(requestPath, data, requestOptions);
}
